import React from 'react';
import { UseFormMethods } from 'react-hook-form';
import { StylesConfig } from 'react-select';
import Select from 'react-select';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
// import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import CurativeRequirement from 'src/models/CurativeRequirement';
import IndexReferenceType from 'src/models/IndexReferenceType';
import Landman from 'src/models/Landman';

interface ICurativeModuleProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    curativeRequirements: Array<CurativeRequirement>;
    runsheetId: number;
    curativeStatuses: Array<IndexReferenceType>;
    projectStaff: Array<Landman>;

    addRow: () => void;
    deleteRow: (index: number) => void;
    updateCurativeRequirements: () => void;
}

const CurativeModule = (props: ICurativeModuleProps) => {
    const paddingRule = '0 1rem 0 1rem';
    // TODO: Abstract this, and figure out a universal styling for it.
    const customStyles: StylesConfig<{ label: string; value: string | number }, false> = {
        control: (provided) => ({
            ...provided,
            minHeight: '30px',    // Set a smaller minHeight
            height: '30px',       // Force a smaller height
            width: '10rem',       // Adjusting form width
            padding: '0px',       // Remove internal padding to make it smaller
            marginRight: '2rem'   // Adjust dropdown position
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0px 8px',   // Adjust padding to make the height smaller
            height: '30px',       // Force height for the container
        }),
        input: (provided) => ({
            ...provided,
            margin: '0px',        // Ensure no margins are added
            padding: '0px',       // Ensure no padding is added
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '30px',       // Force the height of the dropdown indicators
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0px',       // Remove extra padding from the dropdown arrow
        }),
    };

    const curativeHeader = () => {
        return (
            <div style={{ display: 'flex' }}>
                <div className="mr-2 mb-2" style={{ width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ padding: paddingRule, width: '7%' }}>
                            <div>
                                <b>Title Opinion Number</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '15%' }}>
                            <div>
                                <b>Title Defect Issue</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '10%' }}>
                            <div>
                                <b>Status</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '15%' }}>
                            <div>
                                <b>Curative Requirement</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '8%' }}>
                            <div>
                                <b>Date Assigned</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '8%' }}>
                            <div>
                                <b>Completed?</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '10%' }}>
                            <div>
                                <b>Assigned To</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '12%' }}>
                            <div>
                                <b>Brief Description</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '15%' }}>
                            <div>
                                <b>Curative Control Comments</b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            {/* <RHFLegend title="Curative Module" /> */}
            {props.curativeRequirements?.length > 0 && (
                <>
                    {curativeHeader()}
                    {props.curativeRequirements?.map((curative: CurativeRequirement, index: number) => {
                        return (
                            <div
                                key={`Curative-${index + 1}`}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                                className="mb-2"
                            >
                                <input type="hidden" name={`curativeRequirements[${index}].id`} ref={props.register()} />
                                <RHFInputBox
                                    name={`curativeRequirements[${index}].titleOpinionReqNo`}
                                    bodyStyle={{ width: '7%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                <RHFInputBox
                                    name={`curativeRequirements[${index}].reqDescription`}
                                    bodyStyle={{ width: '15%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                <RHFSelect
                                    name={`curativeRequirements[${index}].statusId`}
                                    bodyStyle={{ width: '10%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                    options={props.curativeStatuses.map(cs => { return {value: cs.id, label: cs.name}; })}
                                />

                                <RHFInputBox
                                    name={`curativeRequirements[${index}].curativeRemarks`}
                                    bodyStyle={{ width: '15%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                <RHFInputBox
                                    name={`curativeRequirements[${index}].dateAssigned`}
                                    bodyStyle={{ width: '6%' }}
                                    style={{ width: '100%' }}
                                    type="date"
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                <RHFCheckbox
                                    name={`curativeRequirements[${index}].isCompleted`}
                                    bodyStyle={{ width: '8%', margin: '0' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                {/* <RHFSelect
                                    name={`curativeRequirements[${index}].assignedToId`}
                                    bodyStyle={{ width: '10%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                    options={props.projectStaff.map(ps => { return {value: ps.id, label: ps.firstName + ' ' + ps.lastName}; })}
                                /> */}

                                <Select
                                    name={`curativeRequirements[${index}].assignedToId`}
                                    placeholder={'--Select--'}
                                    options={props.projectStaff.map(u => { return { value: u.id, label: `${u.firstName} ${u.lastName}` }; })}
                                    register={props.register}
                                    errors={props.errors}
                                    isSearchable={true}
                                    styles={customStyles}
                                />
        
                                <RHFInputBox
                                    name={`curativeRequirements[${index}].briefDescription`}
                                    bodyStyle={{ width: '12%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                <RHFInputBox
                                    name={`curativeRequirements[${index}].curativeControlComments`}
                                    bodyStyle={{ width: '15%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />

                                <div onClick={() => props.deleteRow(index)} style={{ width: '2%' }}>❌</div>
                            </div>
                        );
                    })}
                </>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '2rem' }}>
                <Button text="Add Requirement" onClick={() => props.addRow()} intent="primary" />
                <Button text="Save Curative Requirements" onClick={() => props.updateCurativeRequirements()} intent="primary" disabled={!(props.curativeRequirements?.length > 0)} />
            </div>
        </div>
    );
};

export default CurativeModule;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/CurativeModule.tsx